import { format, processNamespace, text } from '@opengov/locale/namespaces';

export const stories = {
  storiesPage: {
    addColor: text(),
    improvingExperience: text(),
    loading: text(),
    maxColors: text(),
    pleaseContact: text(),
    publishedStories: text(),
    scheduledMaintenence: text(),
    skipTo: text(),
    storiesAndPublications: text(),
    stories: text(),
    title: text(),
    withAnyQuestions: text()
  },
  storyList: {
    addFolder: text(),
    addStoriesOrFolders: text(),
    adjustFilters: text(),
    adjustFiltersInFolder: text(),
    all: text(),
    allStories: text(),
    allTemplates: text(),
    analytics: text(),
    analyticsErrorBody: text(),
    analyticsErrorHeader: text(),
    analyticsErrorLink: text(),
    anyone: text(),
    averageTime: text(),
    buildingThePDF: text(),
    cancel: text(),
    cantFindTemplate: text(),
    cantMoveToChild: text(),
    changesSaved: text(),
    changesSavedSuccessfully: text(),
    copy: text(),
    copyFolder: text(),
    copyFolderComplete: text(),
    copyFolderDescription: text(),
    copyFolderFailed: text(),
    copyFolderToRoot: text(),
    copyFolderInExisting: text(),
    copyFolderInExistingDesc: text(),
    copyFolderInNew: text(),
    copyFolderInNewDesc: text(),
    copyFolderSuccess: text(),
    copying: text(),
    copyingFolder: text(),
    copyingStories: text(),
    copyingStoriesProcess: text(),
    copyStories: text(),
    copyStoriesComplete: text(),
    copyStoriesFailed: text(),
    copyStoriesPickLocation: text(),
    copyStoriesSuccess: text(),
    copyTo: text(),
    clearFilter: text(),
    clearFilters: text(),
    clearSelection: text(),
    clickHere: text(),
    create: text(),
    createdBy: text(),
    createdDate: text(),
    createFolder: text(),
    createFromTemplate: text(),
    createNewStory: text(),
    createNewtoOld: text(),
    createOldtoNew: text(),
    createStory: text(),
    createStoryFromTemplate: text(),
    creatingNewFolderProcess: text(),
    customOrganized: text(),
    delete: text(),
    deleted: text(),
    deleteConfirmation: text(),
    deleteFolder: text(),
    deleteFolderDescription: text(),
    deleteFolderStoriesAndSubfoldersPrompt: text(),
    deleteFolderStoriesPrompt: text(),
    deleteStories: format<{ value: number }>(),
    deleteStory: text(),
    deleteStoryDescription: text(),
    deleteThem: text(),
    deleting: text(),
    description: text(),
    destination: text(),
    done: text(),
    drafts: text(),
    editStories: text(),
    exportingPdf: text(),
    exportingPdfTooltip: text(),
    exportingPdfProcessDescription: text(),
    exportFolderPdfFailed: text(),
    exportPdf: text(),
    failedToCopyStories: text(),
    failedToDeleteReport: text(),
    failedToUpdateReport: text(),
    failedToGetStoriesInFolderCount: text(),
    failedToMoveStories: text(),
    filter: text(),
    filterFolders: text(),
    find: text(),
    findStoriesByName: text(),
    findTemplatesByName: text(),
    findTemplate: text(),
    first: text(),
    folderName: text(),
    folderResults: format<{ numberOfFolders: number }>(),
    folder: text(),
    folders: text(),
    from: text(),
    grid: text(),
    image: text(),
    inFolder: text(),
    last: text(),
    list: text(),
    location: text(),
    manageStories: text(),
    me: text(),
    onlyTable: text(),
    onlyGraph: text(),
    move: text(),
    moveFolder: text(),
    moveStoriesToAnotherFolder: text(),
    moveStoriesToRoot: text(),
    moving: text(),
    movingStoriesFrom: text(),
    moveStoriesDisabledNote: text(),
    deleteStoriesDisabledNote: text(),
    multipleFolders: text(),
    mustHaveFolder: text(),
    name: text(),
    nameAZ: text(),
    nameZA: text(),
    nestedTooDeep: text(),
    newStart: text(),
    newStory: text(),
    newSectionName: text(),
    newFolderName: text(),
    next: text(),
    noDraftsFound: text(),
    noDraftsShared: text(),
    noFolder: text(),
    noFoldersFound: text(),
    noFoldersMatching: text(),
    noFoldersWithSameName: text(),
    noParent: text(),
    noStoriesFound: text(),
    noTemplatesFound: text(),
    organization: text(),
    pageName: text(),
    pdfGenerated: text(),
    pdfGeneratedDescription: text(),
    pdfGenerateFailed: text(),
    pdfGenerateFailedDescrption: text(),
    prev: text(),
    processNotCompleted: text(),
    public: text(),
    published: text(),
    unPublished: text(),
    rename: text(),
    renameFolder: text(),
    report: text(),
    organizeFolders: text(),
    organizeSections: text(),
    organizeFolderDescription: text(),
    organizationSectionDescription: text(),
    organizeStories: text(),
    organizeStoriesAndFolders: text(),
    organizeStoriesDescription: text(),
    publication: text(),
    renameFolderDescription: text(),
    save: text(),
    selectTemplate: text(),
    settings: text(),
    shared: text(),
    shares: text(),
    skipTo: text(),
    somethingWentWrongError: text(),
    sort: text(),
    sortBy: text(),
    status: text(),
    stories: text(),
    storiesAndPublications: text(),
    publications: text(),
    signInWithGoogle: text(),
    storiesDeleted: format<{ value: number }>(),
    storiesDeletedDescription: format<{ value: number }>(),
    storiesFailedToDelete: text(),
    storiesMoved: format<{ value: number }>(),
    storiesMovedDescription: format<{ value: number }>(),
    storiesSelected: format<{ value: number }>(),
    storyCopied: text(),
    storyCopyFailed: text(),
    storyCopySuccess: text(),
    storyCreated: text(),
    storyDeleted: text(),
    storyDeletedDescription: text(),
    storyDescription: text(),
    storyFolderCopyFailed: text(),
    storyFolderCreated: text(),
    storyFolderCreatedDescription: format<{ title: string }>(),
    storyFolderCreateFailed: text(),
    storyFolderDeleted: text(),
    storyFolderDeletedDescription: format<{ title: string }>(),
    storyFolderDeleteFailed: text(),
    storyFolderMoved: text(),
    storyFolderMovedDescription: format<{ folder: string; destinationFolder: string }>(),
    storyFolderMoveFailed: text(),
    storyFolderMoveFailedDescription: format<{ folder: string; destinationFolder: string }>(),
    storyFolderRenamed: text(),
    storyFolderRenamedDescription: format<{ title: string }>(),
    storyFolderRenameFailed: text(),
    storyMoved: text(),
    storyMovedDescription: text(),
    storyName: text(),
    storyOrganizeFoldersFailed: text(),
    storyStatusChangeFailed: text(),
    storySelected: format<{ value: number }>(),
    subFoldersPresent: text(),
    tellFirstStory: text(),
    template: text(),
    templates: text(),
    templateDescription: text(),
    templateStart: text(),
    title: text(),
    toStartDownload: text(),
    updated: text(),
    uniquePageViews: text(),
    unsavedChanges: text(),
    unsavedChangesDescription: text(),
    updateNewtoOld: text(),
    updateOldtoNew: text(),
    view: text(),
    viewAllStories: text(),
    viewAllTemplates: text(),
    views: text(),
    visibility: text(),
    welcomeToFolder: text(),
    welcomeToStories: text(),
    whichFolderToTransferStories: text(),
    whichFolderToTransferStoriesAndFolders: text(),
    withStories: format<{ currentFolderStoryCount: number; storyText: string }>(),
    withStoriesAndSubfolders: format<{
      subfolderCount: number;
      subfolderText: string;
      totalStoryCount: number;
      storyText: string;
    }>(),
    yes: text(),
    youHaveNoDrafts: text(),
    youHaveNoStories: text(),
    youHaveNoTemplates: text(),
    yourStories: text(),
    yourTemplates: text(),
    organizePdf: text(),
    selectAllStories: format<{ totalStoriesCount: string }>(),
    selectAllSectionStories: format<{ totalStoriesCount: string }>(),
    changeStatus: text(),
    changeStatusDescription: text(),
    selectStatus: text(),
    storyStatus: text(),
    changeStoryStatus: text(),
    internal: text(),
    draft: text(),
    overrideOnlinePublicationSettings: text(),
    update: text(),
    newStoryName: text(),
    publicationLocation: text(),
    copyToPublication: text(),
    copyToFolder: text(),
    onlyAccessibleByOwner: text(),
    shareWithMembersOfYourOrganization: text(),
    anyoneWithTheLinkCanView: text(),
    allowViewersToFollowForUpdates: text(),
    followAndCommentDesclaimer: text(),
    termsAndConditions: text()
  },
  storyView: {
    aFewSecondsAgo: text(),
    allChangesSaved: text(),
    applyBranding: text(),
    back: text(),
    clearContent: text(),
    clickToEditTitle: text(),
    copy: text(),
    insert: text(),
    copyStory: text(),
    created: text(),
    deleteText: text(),
    draft: text(),
    dragToReorder: text(),
    edit: text(),
    embedCode: text(),
    hideEmbed: text(),
    justNow: text(),
    public: text(),
    unpublished: text(),
    updated: text(),
    menu: text(),
    organization: text(),
    pdfExport: text(),
    setupPdf: text(),
    preview: text(),
    publicUrl: text(),
    publish: text(),
    published: text(),
    publishing: text(),
    refreshEmbeds: text(),
    republish: text(),
    resetContent: text(),
    save: text(),
    saveAndExit: text(),
    saveAsTemplate: text(),
    saved: text(),
    saving: text(),
    settings: text(),
    share: text(),
    showEmbed: text(),
    showLessOptions: text(),
    showMoreOptions: text(),
    status: text(),
    statusDraftDescription: text(),
    statusInternalPublishedDescription: text(),
    statusPublishedDescription: text(),
    story: text(),
    storyUrl: text(),
    template: text(),
    toggleSectionActive: text(),
    unathorizedMessage: text(),
    unpublish: text(),
    view: text(),
    visibility: text(),
    pageLayout: text(),
    pageLayoutAndProposals: text(),
    noProposalsContent: text(),
    addProposalsContent: text(),
    addProposals: text(),
    budget: text(),
    proposals: text(),
    addMore: text(),
    openProposal: text(),
    proposalTooltip: text(),
    proposalReachedLimit: text(),
    removeBudget: text(),
    removeBudgetDesc: text(),
    delete: text(),
    cancel: text(),
    remove: text(),
    replace: text(),
    loadingProposals: text(),
    removeProposal: text(),
    removeProposalDesc: text(),
    maxNumberOfMergeTags: text(),
    maxNumberOfMergeTagsDesc: format<{ maxNumber: number }>(),
    proposalRemoved: text(),
    budgetDeleted: text(),
    removeLastProposalDesc: text(),
    add: text(),
    manageAccess: text()
  },
  publicationCustomCss: {
    customCss: text(),
    exit: text(),
    showingStory: text(),
    select: text(),
    selectStoryToCustomize: text(),
    saveAndApply: text(),
    discard: text(),
    somethingWentWrongError: text(),
    changesSavedFailed: text(),
    applying: text(),
    changesApplied: text(),
    changesAppliedSuccessfully: text(),
    customCssStyling: text(),
    customCssHint: text(),
    currentStory: text(),
    publication: text(),
    activeElement: text(),
    tagName: text(),
    possibleSelectors: text(),
    styles: text(),
    parentElement: text(),
    makeElementActive: text()
  },
  publicationCustomCssDialogs: {
    applyStyling: text(),
    applyStylingDescription: text(),
    applyStylingNote: text(),
    note: text(),
    apply: text(),
    discardChanges: text(),
    changesWillBeLost: text(),
    discard: text(),
    cancel: text()
  },
  publicationList: {
    publications: text(),
    allPublications: text(),
    createdBy: text(),
    failedToGetPublication: text(),
    failedToCreatePublication: text(),
    noPublicationsFound: text(),
    publicationDeleted: text(),
    publicationDeletedDescription: format<{ title: string }>(),
    publicationFailedToDelete: text(),
    search: text(),
    searchPublicationsByName: text(),
    somethingWentWrongError: text(),
    deletePublicationDescription: text(),
    customReportWarning: text(),
    deleteEmptyPublicationDescriptionPart1: text(),
    deleteEmptyPublicationDescriptionPart2: text(),
    deleteEmptyPublicationDescriptionPart3: text(),
    deletedPublicationFolderText: text(),
    deletedPublicationTitle: format<{ title: string }>(),
    deletePublication: text(),
    deleteConfirmation: text(),
    delete: text(),
    cancel: text(),
    createNewPublication: text(),
    youHaveNoPublications: text(),
    youHaveNoPublicationsNonAdmin: text(),
    welcomeToPublications: text(),
    settings: text(),
    recentlyViewed: text(),
    failedToFetchRecentlyViewed: text(),
    deleteSection: text(),
    deleteSectionDescription: text(),
    view: text(),
    allViews: text(),
    export: text(),
    publish: text(),
    selectAll: text(),
    clear: text(),
    access: text(),
    selected: text(),
    edit: text()
  },
  publicationView: {
    adjustFilters: text(),
    addSection: text(),
    addSectionTitle: text(),
    addSectionDescription: text(),
    addSectionDescriptionNonAdmin: text(),
    addStoriesInSection: text(),
    addStoriesInSectionNonAdmin: text(),
    addReportEmbedsInPublication: text(),
    allPublicationStories: text(),
    allPublicationReports: text(),
    customReports: text(),
    copySection: text(),
    created: text(),
    clearSelection: text(),
    deletePublicationDescription: text(),
    customReportWarning: text(),
    deleteEmptyPublicationDescriptionPart1: text(),
    deleteEmptyPublicationDescriptionPart2: text(),
    deleteEmptyPublicationDescriptionPart3: text(),
    deletedPublicationFolderText: text(),
    deletedPublicationTitle: format<{ title: string }>(),
    deleteSection: text(),
    deleted: text(),
    editDataUpdateFrequency: text(),
    exportSection: text(),
    searchPublicationsByName: text(),
    search: text(),
    deletePublication: text(),
    deleteConfirmation: text(),
    failedToUpdateType: text(),
    share: text(),
    pdfExport: text(),
    manage: text(),
    manageReports: text(),
    reportSelected: format<{ value: number }>(),
    reportsSelected: format<{ value: number }>(),
    reportsDeletedBody: format<{ value: number }>(),
    edit: text(),
    makeDuplicate: text(),
    addNewStory: text(),
    delete: text(),
    createFromScratch: text(),
    createFromTemplate: text(),
    createFromScratchDescription: text(),
    createFromTemplateDescription: text(),
    failedToGetSections: text(),
    lastUpdated: text(),
    noSections: text(),
    publicationViewSummary: text(),
    searchSections: text(),
    sections: text(),
    somethingWentWrongError: text(),
    storiesAndPublications: text(),
    newSubSectionLabel: text(),
    newSectionLabel: text(),
    noReportsFound: text(),
    cancel: text(),
    add: text(),
    addNewSelection: text(),
    descriptionPlaceholder: text(),
    welcomeToPublications: text(),
    welcomeToPublicationsNonAdmin: text(),
    sectionFormLabel: text(),
    location: text(),
    sectionCreated: text(),
    sectionCreatedDescription: text(),
    filterPlaceHolder: text(),
    failedToDeleteType: text(),
    failedToUpdate: text(),
    failedToUpdateBody: text(),
    failedToCreatePublicationSection: text(),
    failedToUpdatePublicationSection: text(),
    sectionNamePlaceholder: text(),
    welcomeToSection: text(),
    welcomeToSectionNonAdmin: text(),
    welcomeToPublicationReports: text(),
    failedToLoadStories: text(),
    failedToUpdateLastSeen: text(),
    failedToUpdatePublication: text(),
    moreActions: text(),
    move: text(),
    storiesCountDescription: text(),
    nestedTooDeep: text(),
    pdfGenerated: text(),
    downloadFile: text(),
    sectionDeletedSuccessTitle: text(),
    sectionDeletedSuccessDesc: text(),
    sectionDeletedFailedTitle: text(),
    sectionDeletedFailedDesc: text(),
    deleteSectionDescription: text(),
    save: text(),
    organizeSections: text(),
    organizeStories: text(),
    organizeStoriesDescription: text(),
    reorderSectionDescription: text(),
    reorder: text(),
    copySectionDescription: text(),
    noParent: text(),
    noParentSection: text(),
    copyFolderToRoot: text(),
    copyFolderInExisting: text(),
    copyFolderInExistingDesc: text(),
    copyFolderInNew: text(),
    copyFolderInNewDesc: text(),
    copyFolderToRootSection: text(),
    copyFolderInExistingSection: text(),
    copyFolderInExistingSectionDesc: text(),
    copyFolderInNewSection: text(),
    copyFolderInNewSectionDesc: text(),
    copySectionSuccess: text(),
    sectionName: text(),
    cantMoveToChild: text(),
    filterSections: text(),
    noSectionsWithSameName: text(),
    copyingSection: text(),
    creatingNewSectionProcess: text(),
    copySectionComplete: text(),
    copySectionFailed: text(),
    exportingPdfProcessDescription: text(),
    pdfGenerateFailedDescrption: text(),
    moveStoriesToRoot: text(),
    inSection: text(),
    moveSection: text(),
    storySectionMoved: text(),
    storySectionMovedDescription: format<{ section: string; destinationSection: string }>(),
    storySectionMoveFailed: text(),
    storySectionMoveFailedDescription: format<{ section: string; destinationSection: string }>(),
    organizePdf: text(),
    setupOnlinePublication: text(),
    onlinePublicationURL: text(),
    onlinePublicationStatus: text(),
    view: text(),
    allViews: text(),
    export: text(),
    publish: text(),
    selectAll: text(),
    clear: text(),
    access: text(),
    selected: text(),
    updateLink: text(),
    copyLink: text(),
    noPublicationSameName: text(),
    noSectionSameName: text(),
    disabledFeature: text(),
    populatingPublicationsEmbeds: text(),
    publicationCustomCss: text(),
    publicationCustomCssBadge: text(),
    publicationCustomCssDisabledTooltip: text(),
    publicationCopied: text(),
    publicationCopying: text(),
    publicationCopiedDescription: format<{ publication: string }>(),
    publicationCopyingDescription: text(),
    publicationCopyFailed: text(),
    publicationCopyFailedDescription: text(),
    report: text(),
    reports: text(),
    reportDeletedBody: text(),
    refreshEmbedsSuccess: text(),
    refreshEmbedsSuccessDescription: format<{ type: string }>(),
    refreshEmbedsFailure: text(),
    refreshEmbedsFailureDescription: text(),
    reportLoadFailedMessage: text(),
    reportDeletedMessage: text(),
    viewAllReports: text(),
    copyPublication: text(),
    copyPublicationLoaderText: text(),
    useSnapshot: text(),
    refreshOnUpdate: text(),
    liveView: text(),
    updatePublicationDescription: text(),
    update: text(),
    labelDataUpdateFreq: text(),
    deleteReportEmbed: text(),
    deleteReportEmbeds: format<{ value: number }>(),
    deleteReportEmbedDescription: text(),
    unableToBulkDeleteReportEmbeds: text(),
    unableToBulkUpdateReportEmbeds: text(),
    storyStatusChanged: text(),
    storyStatusChangedDescription: text(),
    storyStatusUpdating: text(),
    storyStatusUpdatingDescription: text(),
    storyStatusUpdateError: text(),
    storyStatusUpdateErrorDescription: text(),
    reportOrViewDeleted: text(),
    setupPdf: text()
  },
  publicationModals: {
    cancel: text(),
    confirm: text(),
    confirmPublication: text(),
    confirmPublicationDesc: text(),
    create: text(),
    save: text(),
    createNewPublication: text(),
    editPublication: text(),
    editSection: text(),
    description: text(),
    descriptionPlaceholer: text(),
    enterNamePlaceholder: text(),
    publicationName: text(),
    sectionName: text(),
    moveStoriesFrom: text(),
    moveStoriesPlaceholder: text(),
    selectFolderTitle: text(),
    selectFolderDesc: text(),
    sectionTitle: text(),
    noStoriesFoundInPublication: text(),
    noStoriesFoundInSection: text(),
    pdfPreviewNote: text(),
    publicationTitle: text(),
    noSameName: text(),
    copyPublication: text(),
    copy: text(),
    copyOf: text(),
    copyOption: text(),
    copyWithStatus: text(),
    copyWithoutStatus: text(),
    copyWithoutStatusWarning: text()
  },
  modals: {
    actuals: text(),
    actualsAsPercent: text(),
    actualsVsBudget: text(),
    add: text(),
    addBackground: text(),
    addContent: text(),
    addEmbed: text(),
    addImage: text(),
    addTile: text(),
    addTableTile: text(),
    addVideo: text(),
    adjustPageMargins: text(),
    adjustSpacing: text(),
    adminsOnly: text(),
    alt: text(),
    altPlaceholder: text(),
    apply: text(),
    applyBranding: text(),
    applyBrandingSuccessful: text(),
    applyBrandingText: text(),
    anyoneWithTheLinkCanView: text(),
    bottomMargin: text(),
    bottomPadding: text(),
    budgetOnlyReportWarning: text(),
    cancel: text(),
    change: text(),
    category: text(),
    characters: text(),
    clear: text(),
    clearContent: text(),
    clearContentText: text(),
    column: text(),
    configurations: text(),
    copy: text(),
    copyStory: text(),
    copyTo: text(),
    copyToTemplate: text(),
    couldNotGetURL: text(),
    customizeSpacing: text(),
    changeStatus: text(),
    changeStatusDescription: text(),
    dataDisplay: text(),
    dateOfExport: text(),
    deleteConfirm: text(),
    deleteContent: text(),
    deleteContentText: text(),
    deleteText: text(),
    description: text(),
    display: text(),
    done: text(),
    draft: text(),
    dragThe: text(),
    embedDataRefreshed: text(),
    embedLabel: text(),
    embedSnippet: text(),
    copiedToClipboard: text(),
    embedsUpdated: text(),
    enlargeSizes: text(),
    enableClickThrough: text(),
    errorCreatingTile: text(),
    errorUploadingMedia: text(),
    everyone: text(),
    export: text(),
    failedToUpload: text(),
    failedToUploadImage: text(),
    failedToUploadVideo: text(),
    errorEmbedAddUpdate: text(),
    errorPreviewEmbed: text(),
    somethingWentWrong: text(),
    previewEmbedErrorMessage: text(),
    filterFolders: text(),
    folderLocation: text(),
    fonts: text(),
    generate: text(),
    copyEmbedSnippet: text(),
    goToView: text(),
    graph: text(),
    groupDataBy: text(),
    height: text(),
    imageLink: text(),
    imageLinkPlaceholder: text(),
    internal: text(),
    intoThisBox: text(),
    leftMargin: text(),
    liveView: text(),
    loadingPreview: text(),
    maximumFileSize: text(),
    measurementColumn: text(),
    measurementColumnPlaceholder: text(),
    metric: text(),
    month: text(),
    new: text(),
    newStoryName: text(),
    no: text(),
    noReports: text(),
    noSavedViews: text(),
    noStoriesFound: text(),
    noVisualizationSupported: text(),
    optional: text(),
    orClickToSelect: text(),
    organization: text(),
    onlyAccessibleByOwner: text(),
    pageFootnotes: text(),
    pageNumber: text(),
    pdfExport: text(),
    pdfExportFailure: text(),
    pdfExportFailureText: text(),
    pdfExportText: text(),
    pdfPreviewNote: text(),
    pdfPreviewFailureText: text(),
    pdfPreviewText: text(),
    pickCopyStoryLocation: text(),
    publication: text(),
    storyTitleExists: text(),
    preview: text(),
    private: text(),
    public: text(),
    publicationLocation: text(),
    published: text(),
    publishNow: text(),
    refreshOnUpdate: text(),
    remove: text(),
    report: text(),
    deleted: text(),
    republish: text(),
    republishStory: text(),
    required: text(),
    reset: text(),
    resetContent: text(),
    resetContentText: text(),
    rightMargin: text(),
    save: text(),
    savedView: text(),
    searchingForReports: text(),
    searchingForSavedViews: text(),
    selectDataDisplay: text(),
    selectForVisualization: text(),
    selectReport: text(),
    selectSavedView: text(),
    selectToPreview: text(),
    selectToCreateTable: text(),
    selectTableTypeName: text(),
    selectTableTypeTitle: text(),
    settings: text(),
    shareWithMembersOfYourOrganization: text(),
    startingPageNumber: text(),
    startingPageMinError: text(),
    startingPageMaxError: text(),
    startingPageWholeNumberError: text(),
    story: text(),
    storyCopied: text(),
    storyCopyFailed: text(),
    storyCopySuccess: text(),
    storyDeleted: text(),
    storyDeletedDescription: text(),
    storyTitle: text(),
    folderTitle: text(),
    storyCopiedToTemplates: text(),
    storyNotCopiedToTemplates: text(),
    templateNotSaved: text(),
    reportColumnPlaceholder: text(),
    reportColumnSetting: text(),
    reportLinkText: text(),
    displayAccountCodesText: text(),
    targetColumn: text(),
    targetColumnPlaceholder: text(),
    template: text(),
    templateSaved: text(),
    tilePreview: text(),
    tileWarning: text(),
    title: text(),
    topMargin: text(),
    unitInches: text(),
    topPadding: text(),
    transcriptLink: text(),
    transcriptLinkPlaceholder: text(),
    unitPixels: text(),
    unpublished: text(),
    update: text(),
    updated: text(),
    updateBackground: text(),
    updateEmbed: text(),
    updateExistingStory: text(),
    updateExistingStoryText: text(),
    updateImage: text(),
    updateSetting: text(),
    updateTile: text(),
    updateTableTile: text(),
    updateVideo: text(),
    upload: text(),
    uploading: text(),
    useSnapshot: text(),
    valueRow: text(),
    valueRowPlaceholder: text(),
    videoTranscript: text(),
    visualization: text(),
    visibility: text(),
    v2EmbedFormDisabled: text(),
    width: text(),
    yearSelection: text(),
    yes: text(),
    headerFooterForAllStory: text(),
    headerFooterForFirstStory: text(),
    headerFooterForLastStory: text(),
    headerFooterForBothStory: text(),
    headerFooterForNoStory: text(),
    showFooterName: text(),
    showHeaderName: text(),
    detailsTableLabel: text(),
    summaryTableLabel: text(),
    showFooterTitle: text(),
    showHeaderTitle: text(),
    exportStoryTitle: text(),
    detailTableWarningNote: text(),
    detailTableMaxLimitMessage1: text(),
    detailTableMaxRowLimit: text(),
    detailTableMaxLimitMessage2: text(),
    viewReportLink: text(),
    detailTableMaxLimitMessage3: text(),
    detailTableMaxLimitMessage4: text(),
    detailTableMaxColumnErrorTitle: text(),
    detailTableMaxColumnErrorBody: text(),
    tableTypeAutoSelectionWarning: text(),
    sharePublication: text(),
    shareDescription: text(),
    generateLink: text(),
    navigationMenuIsNotSetup: text(),
    navigationMenuNotSetupDescription: text(),
    okayGotIt: text(),
    shareOnlinePublication: text(),
    copyLinkDescription: text(),
    close: text(),
    openInBrowser: text(),
    onlinePublicationURL: text(),
    deleteReport: text(),
    deleteReportDescription: text(),
    deleteConfirmation: text(),
    confirm: text(),
    budget: text(),
    enterBudget: text(),
    loadingBudgets: text(),
    searchingBudgets: text(),
    proposals: text(),
    enterProposals: text(),
    loadingProposals: text(),
    searchingProposals: text(),
    noBudgets: text(),
    noProposals: text(),
    addProposals: text(),
    selectNewProposal: text(),
    replaceProposal: text(),
    replaceProposalDesc: text(),
    replace: text(),
    replaceBudget: text(),
    replaceBudgetDesc: text(),
    selectNewBudget: text(),
    currentProposal: text(),
    newProposal: text(),
    replaceWith: text(),
    addBudget: text(),
    reportFailedToLoad: text(),
    copyToFolder: text(),
    copyToPublication: text(),
    spacing: text(),
    addPageBreak: text(),
    resetToDefault: text(),
    allowViewersToFollowForUpdates: text(),
    followAndCommentDesclaimer: text(),
    termsAndConditions: text()
  },
  editor: {
    add: text(),
    addColor: text(),
    addContent: text(),
    addSlide: text(),
    backgroundColor: text(),
    backgroundImage: text(),
    blockquote: text(),
    bold: text(),
    brandingPanel: text(),
    centerAlign: text(),
    clearFormatting: text(),
    customPanel: text(),
    deleteSlide: text(),
    deleteText: text(),
    disabledReportTable: text(),
    embed: text(),
    enterLinkText: text(),
    enterLinkURL: text(),
    headingOne: text(),
    headingThree: text(),
    headingTwo: text(),
    image: text(),
    italic: text(),
    justifyAlign: text(),
    layout: text(),
    leftAlign: text(),
    link: text(),
    maxContentBlocksReached: text(),
    moveDown: text(),
    moveUp: text(),
    noContentError: text(),
    orderedList: text(),
    overlayColor: text(),
    preview: text(),
    report: text(),
    reportGraph: text(),
    reportTable: text(),
    reportCustom: text(),
    mediaBlockLabel: text(),
    rightAlign: text(),
    textColor: text(),
    underlined: text(),
    unorderedList: text(),
    update: text(),
    video: text(),
    progressTracker: text(),
    eventTitlePlaceholder: text(),
    eventDescriptionPlaceholder: text(),
    addEvent: text(),
    eventStatusNotStarted: text(),
    eventStatusInProgress: text(),
    eventStatusCompleted: text(),
    showPreviewLabel: text(),
    orientationLabel: text(),
    save: text(),
    cancel: text(),
    inactiveMergeTags: text(),
    inactiveMergeTagsBudget: text(),
    inactiveMergeTagsFields: text(),
    inactiveMergeTagsBudgetDesc: text(),
    removeAllInactiveMergeTags: text(),
    inactiveMergeTagsDesc: text(),
    showMore: text(),
    showLess: text(),
    maxNumberOfFields: text(),
    generateSummary: text(),
    unableToGenerateSummary: text(),
    unableToGenerateAnswer: text(),
    somethingWentWrongError: text(),
    unableToLoadCustomReports: text(),
    updateReportTable: text(),
    updateTile: text(),
    updateMedia: text(),
    thisMayTakeAFewMoments: text(),
    wereStillWorkingOnIt: text(),
    holdOnTight: text(),
    almostThere: text(),
    unableToFetchAiAdminSettings: text(),
    aiPrompt: {
      somethingWentWrongError: text(),
      unableToGenerateAnswer: text(),
      askAiToWrite: text(),
      askAiDescription: text(),
      tellOgAssist: text(),
      contentLength: text(),
      short: text(),
      medium: text(),
      long: text(),
      info: text(),
      generate: text(),
      generatingLoader: text(),
      cancel: text(),
      insert: text()
    },
    contextMenus: {
      generateSummary: text(),
      explainThis: text()
    },
    slashCommands: {
      askOpenGov: text(),
      addImage: text(),
      headingOne: text(),
      headingTwo: text(),
      headingThree: text(),
      bulletedList: text(),
      numberedList: text()
    },
    explainThis: {
      explainThis: text(),
      heresWhatWeFound: text(),
      okay: text()
    },
    generateSummaryModal: {
      generateReportSummary: text(),
      setPreferencesToGenerate: text(),
      contentLength: text(),
      short: text(),
      medium: text(),
      long: text(),
      generate: text(),
      cancel: text(),
      generatingSummary: text(),
      info: text(),
      insert: text()
    }
  },
  storiesSettings: {
    advanced: text(),
    analytics: text(),
    analyticsBodyText: text(),
    analyticsLabel: text(),
    analyticsPlaceholder: text(),
    back: text(),
    backgroundColor: text(),
    body: text(),
    branding: text(),
    colors: text(),
    colorSelectorsText: text(),
    couldNotGetURL: text(),
    customFontText: text(),
    dragText: text(),
    dropzoneLabel: text(),
    errorUploadingLogo: text(),
    failedToUpload: text(),
    failedToUploadImage: text(),
    fontColor: text(),
    fonts: text(),
    footer: text(),
    footerDropzoneLabel: text(),
    header: text(),
    headlineFont: text(),
    logo: text(),
    logoOptionBoth: text(),
    logoOptionFooterOnly: text(),
    logoOptionHeaderOnly: text(),
    logoOptionUniqueFooter: text(),
    loadingPreview: text(),
    maximumFileSize: text(),
    orClickToSelect: text(),
    paragraphFont: text(),
    preview: text(),
    previewAlt: text(),
    save: text(),
    saved: text(),
    saving: text(),
    settings: text(),
    settingsSaved: text(),
    upload: text(),
    uploading: text(),
    uploadLogoText: text(),
    progressTracker: text(),
    cancel: text(),
    progressTrackerSettingsDescription: text(),
    statusAndColor: text(),
    labelPositioning: text(),
    addStatus: text(),
    labelPreview: text(),
    editStatusColor: text(),
    labelPositioningTooltip: text()
  },
  onlinePublication: {
    activeMenuItems: text(),
    add: text(),
    addMenu: text(),
    addStories: text(),
    addStoriesDesc: text(),
    addMenuDescription: text(),
    cancel: text(),
    changeDisplayName: text(),
    changeDisplayNameDesc: text(),
    changeStory: text(),
    changesSaved: text(),
    changesSavedSuccessfully: text(),
    changesSavedFailed: text(),
    confirm: text(),
    delete: text(),
    deleteMenu: text(),
    deletMenuDesc: text(),
    displayName: text(),
    displayNameUpdated: text(),
    displayNameUpdatedDesc: text(),
    done: text(),
    emptyMenuDesc: text(),
    emptyMenuTitle: text(),
    emptyStoriesTitle: text(),
    emptyStoriesDesc: text(),
    enableLogoNavigation: text(),
    enterName: text(),
    errorDescription: text(),
    failedMenuItems: text(),
    failedToDeleteMenu: text(),
    failedToGetBranding: text(),
    failedToGetPublicationData: text(),
    failedToUpdate: text(),
    failedToSaveBranding: text(),
    fontColor: text(),
    fontStyle: text(),
    highlightColor: text(),
    idleMenuItems: text(),
    logo: text(),
    logoDescription: text(),
    logoRequirements: format<{ dimensions: string; fileSize: string; fileTypes: string }>(),
    logoRemoved: text(),
    logoRemovedDesc: text(),
    logoUploaded: text(),
    logoUploadedDesc: text(),
    maxMenuLimit: text(),
    menu: text(),
    menuName: text(),
    menuDeleted: text(),
    menuDeletedDesc: format<{ name: string }>(),
    navBar: text(),
    navBarDesc: text(),
    navBarColor: text(),
    newMenuAdded: text(),
    newMenuAddedDescription: format<{ name: string }>(),
    noSameName: text(),
    noSameStoryName: text(),
    onlineOrganizeStories: text(),
    onlineOrganizeStoriesDesc: text(),
    originalStoryName: text(),
    preview: text(),
    setupOnlinePublication: text(),
    singleStoryTooltip: text(),
    style: text(),
    styleDescription: text(),
    websiteAndSocialMedia: text(),
    websiteAndSocialMediaDescription: text(),
    addLink: text(),
    mediaLink: text(),
    linkName: text(),
    linkURL: text(),
    linkURLDescription: text(),
    facebookURL: text(),
    facebookURLDescription: text(),
    xURL: text(),
    xURLDescription: text(),
    maxMediaURL: text(),
    failureText: text(),
    facebook: text(),
    x: text(),
    title: text(),
    link: text(),
    reorder: text(),
    remove: text(),
    removeStoryDescription: text(),
    removeLogo: text(),
    removeLogoResult: text(),
    sampleMenu: text(),
    save: text(),
    saveChangesMenuReorder: text(),
    searchStory: text(),
    selectStory: text(),
    showLogoOnFooter: text(),
    somethingWentWrongError: text(),
    stickyNavBarDesc: text(),
    storiesAdded: text(),
    storiesAddedDesc: text(),
    unsavedChanges: text(),
    unsavedChangesDescription: text(),
    yes: text(),
    styleNavBarContent: text(),
    styleFooterContent: text(),
    default: text(),
    updatingPreview: text(),
    failedToSavePfs: text(),
    backgroundColor: text(),
    publicationName: format<{ name: string }>(),
    tableOfContentsTab: {
      header: text(),
      tocDescription: text(),
      tocToggleLabel: text(),
      menuNameLabel: text(),
      menuNameDescription: text(),
      pageTitleLabel: text(),
      pageTitleDescription: text(),
      uploadHeaderTitle: text(),
      uploadHeaderDescription: text(),
      headerHeightLabel: text(),
      columnLayoutLabel: text(),
      option1Column: text(),
      option2Columns: text(),
      option3Columns: text(),
      uploadSuccessToastTitle: text(),
      uploadSuccessToastBody: text(),
      preview: text(),
      failedToFetchToc: text(),
      pageTitleRequired: text(),
      menuNameRequired: text(),
      nothingToPreview: text(),
      setTocAsHomePage: text(),
      descriptionLabel: text(),
      descriptionPlaceholder: text()
    },
    deactivateBannerHeader: text(),
    deactivateBannerPointThree: text(),
    deactivateBannerPointOne: text(),
    deactivateBannerPointTwo: text(),
    deactivateLink: text(),
    deactivateLinkDesc: text(),
    deactivate: text(),
    share: text(),
    updateLink: text(),
    nowYouCanCopy: text(),
    publicationLinkGenerated: text(),
    changesWhereUpdated: text(),
    linkUpdated: text(),
    failedToGenerateTheLink: text(),
    enableGoogleTranslate: text()
  },
  subjectClaims: {
    failedToFetchSubjectClaims: text(),
    failedToSaveSubjectClaims: text(),
    failedToDeleteSubjectClaim: text(),
    successfullyUpdateSubjectClaim: text(),
    somethingWentWrongError: text(),
    failedToFetchSubjectGroupIds: text(),
    accessUpdated: text(),
    peopleWithAccess: text(),
    manageAccess: text(),
    manageAccessDescription: text(),
    publicationManageAccessDescription: text(),
    placeholder: text(),
    save: text(),
    cancel: text(),
    name: text(),
    view: text(),
    edit: text(),
    export: text(),
    publish: text(),
    oneMember: text(),
    members: format<{ count: number }>(),
    admins: text(),
    more: format<{ count: number }>(),
    permissionLevel: text(),
    manageShared: text(),
    manageSharedAndViewAll: text(),
    manageSharedAndCreateNew: text(),
    manageAll: text(),
    fullAccess: text(),
    contributorDescription: text(),
    reviewerDescription: text(),
    authorDescription: text(),
    editorDescription: text(),
    contributor: text(),
    reviewer: text(),
    author: text(),
    editor: text(),
    emailInvites: text()
  },
  pdfSetup: {
    setupPdf: text(),
    discard: text(),
    saveAndExit: text(),
    export: text(),
    selectStories: text(),
    allPublicStories: text(),
    allInternalStories: text(),
    allDraftStories: text(),
    cancel: text(),
    continue: text(),
    addStoryToPdf: text(),
    removeStoryFromPdf: text(),
    openSidebar: text(),
    closeSidebar: text(),
    toggleStoryVisibility: format<{ storyName: string }>(),
    hiddenStoryTooltip: text(),
    visibleStoryTooltip: text(),
    goToStory: format<{ storyName: string }>(),
    index: text(),
    somethingWentWrong: text(),
    coverStory: text(),
    coverStoryDescription: text(),
    select: text(),
    none: text(),
    selectStoryToPreview: text(),
    loading: text(),
    pageMargins: text(),
    pdfScale: text(),
    enlargeFonts: text(),
    default: text(),
    custom: text(),
    left: text(),
    right: text(),
    top: text(),
    bottom: text(),
    headerControls: text(),
    footerControls: text(),
    headerInfo: text(),
    allStory: text(),
    firstStory: text(),
    lastStory: text(),
    bothStory: text(),
    noStory: text(),
    showPublicationName: text(),
    showSectionName: text(),
    showExportTimestamp: text(),
    showPageNumbers: text(),
    controlHeaderTitle: text(),
    controlHeaderDescription: text(),
    controlFooterTitle: text(),
    controlFooterDescription: text(),
    fromFirstPage: text(),
    onlyAfterToc: text(),
    tableOfContents: text(),
    edit: text(),
    preview: text(),
    storyCount: format<{ current: number; total: number }>(),
    previousStory: text(),
    nextStory: text(),
    zoomIn: text(),
    zoomOut: text(),
    storyMode: text(),
    generatingPdf: text(),
    pdfPreview: text(),
    previous: text(),
    next: text(),
    titleAndPageSeparator: text(),
    whitespace: text(),
    dotted: text(),
    fontType: text(),
    showTableOfContents: text(),
    enterWatermarkText: text(),
    watermark: text(),
    applyWatermark: text(),
    showHeader: text(),
    showFooter: text(),
    addPageBreak: text(),
    removePageBreak: text(),
    noStoriesAvailable: text(),
    storyTitle: text(),
    dateOfExport: text(),
    pageNumber: text(),
    startingPageNumber: text(),
    pageFootNotes: text(),
    pdfStyling: text()
  }
};

export const storiesMsgs = processNamespace({ stories }).stories;

export type IStoriesNamespace = typeof stories;
